import React from 'react';
import { TOnChangeCheckbox } from 'common/types/common/onChangeCheckbox';
import { IListItem } from 'common/types/common/listItem';
import { IFilterSettings } from 'common/constants/types/filterSettings';

import Item from './Item';

export const CheckboxList = ({
  items,
  onChange,
  state
}: CheckboxListProps) => (
  <>
    {items.map(({ key, value, icon, iconColor }) => (
      <Item
        key={key}
        itemKey={key}
        title={value}
        icon={icon}
        iconColor={iconColor}
        onChange={onChange}
        state={state}
      />
    ))}
  </>
);

export interface CheckboxListItem extends IListItem, IFilterSettings {}

export interface CheckboxListProps {
  items: CheckboxListItem[];
  onChange?: TOnChangeCheckbox;
  state: {
    [key: string]: boolean;
  };
};
